import {FormikSelect} from '@flexinet/ui-components';
import {FieldProps} from 'formik';
import {SelectProps} from '@mantine/core';

import {useAllBillableUnitsQuery} from '../hooks/useBillableUnitsQuery';
import {BillableUnit} from '../types';

// FNP-802: the selector a RatePlan uses to pick the unit it prices. Labels carry the
// meter alongside the name ("1000 Domains Managed — domains.created") so the person
// choosing can see WHAT IS MEASURED, not just the display name — picking the wrong unit
// silently prices the wrong meter.
//
// It reads EVERY page (FNP-1881). It used to read the table's first page only, so the
// rate-plans form could offer just the first 10 units.
export const BillableUnitsDropdown = (props: FieldProps & SelectProps) => {

    const {items} = useAllBillableUnitsQuery();

    const selectOptions = items.map((item: BillableUnit) => {
        const meterCode = item.meter?.meterCode ?? item.meterId;
        return {
            value: item.id,
            label: meterCode ? `${item.name} — ${meterCode}` : item.name,
        };
    });

    return <FormikSelect {...props} data={selectOptions}/>;
};
